export function setEndDate(date) {
    if (date === undefined || date === '') {
        return ""
    }
    const ym = date.split('-')
    const d = getDaysInMonth(ym[0], ym[1])

    return date + "-" + d + "T23:59:59"
}

export function setStartDate(date) {
    if (date === undefined || date === '') {
        return ""
    }
    return date + "-01T00:00:01"
}

export function setEndTime(date) {
    if (date === undefined || date === '') {
        return ""
    }

    return date + "T23:59:59"
}

export function setStartTime(date) {
    if (date === undefined || date === '') {
        return ""
    }
    return date + "T00:00:01"
}

function getDaysInMonth(year, month) {
    const m = parseInt(month);
    const y = parseInt(year);
    if (m === 2) {
        return y % 4 === 0
            ? 29
            : 28;
    }
    const shortMonths = [4,6,9,11];
    if (shortMonths.includes(m)) {
        return 30;
    }
    return 31;
}

export function parseDates(str) {
    const dateAndTime = str.trim().split(" ")
    const date = dateAndTime[0].trim().split("-")
    const time = dateAndTime[1].trim().split(":")

    return {
        y: date[2],
        m: date[1],
        d: date[0],
        h: time[0],
        min: time[1],
        s: time[2] ? time[2] : 0
    }
}

export function parseTimeStamp(ts) {
    const defaultReturn = {
        y: "",
        m: "",
        d: "",
        h: "",
        min: "",
        s: ""
    }

    if (ts === undefined || !ts.includes("T")) {
        return defaultReturn
    }

    const dateAndTime = ts.trim().split("T")
    if (dateAndTime.length !== 2) {
        return defaultReturn
    }

    const date = dateAndTime[0].trim().split("-")
    if (date.length !== 3) {
        return defaultReturn
    }

    const time = dateAndTime[1].trim().split(":")
    if (time.length < 2 || time.length > 3) {
        return defaultReturn
    }

    return {
        y: date[0] ? date[0] : "",
        m: date[1] ? date[1] : "",
        d: date[2] ? date[2] : "",
        h: time[0] ? time[0] : "",
        min: time[1] ? time[1] : "",
        s: time[2] ? time[2] : ""
    }
}

export function parseDate(ts) {
    const defaultReturn = {
        y: "",
        m: "",
        d: ""
    }

    const date = ts.trim().split("-")
    if (date.length !== 3) {
        return defaultReturn
    }

    return {
        y: date[0] ? date[0] : "",
        m: date[1] ? date[1] : "",
        d: date[2] ? date[2] : ""
    }
}

export function compareDates(dateOne, dateTwo) {
    return dateOne.y !== dateTwo.y ? dateOne.y - dateTwo.y :
           dateOne.m !== dateTwo.m ? dateOne.m - dateTwo.m :
           dateOne.d !== dateTwo.d ? dateOne.d - dateTwo.d :
           dateOne.h !== dateTwo.h ? dateOne.h - dateTwo.h :
           dateOne.min !== dateTwo.min ? dateOne.min - dateTwo.min :
           dateOne.s - dateTwo.s
}

export function getMonthByNumber(num) {
    if (num === undefined || num === "" || num < 1 || num > 12) {
        return ""
    }

    const months = [
        'январь',
        'февраль',
        'март',
        'апрель',
        'май',
        'июнь',
        'июль',
        'август',
        'сентябрь',
        'октябрь',
        'ноябрь',
        'декабрь'
    ]

    return months[num - 1]
}

export function getDefaultNameExactToMonths(stationName, startTime, endTIme) {
    let start = parseTimeStamp(startTime)
    let end = parseTimeStamp(endTIme)

    if (start.y === end.y && start.m === end.m) {
        return stationName + "_" +
            getMonthByNumber(start.m) + " " + start.y
    }

    return stationName + "_" +
        getMonthByNumber(start.m) + " " + start.y + "_" +
        getMonthByNumber(end.m) + " " + end.y
}

export function getDefaultNameExactToDays(stationName, startTime, endTIme) {
    let start = parseTimeStamp(startTime)
    let end = parseTimeStamp(endTIme)

    if (start.y === end.y && start.m === end.m && start.d === end.d) {
        return stationName + "_" +
            start.d + "." + start.m + "." + start.y
    }

    return stationName + "_" +
        start.d + "." + start.m + "." + start.y + "_" +
        end.d + "." + end.m + "." + end.y
}

export function getDefaultDateName(stationName, startTime, endTIme) {
    let start = parseDate(startTime.replaceAll("T00:00:01", "").replaceAll("T00:00:01", ""))
    let end = parseDate(endTIme.replaceAll("T23:59:59", "").replaceAll("T00:00:01", ""))
    if (start.y === end.y && start.m === end.m && start.d === end.d) {
        return stationName + "_" +
            start.d + "." + start.m + "." + start.y
    }

    return stationName + "_" +
        start.d + "." + start.m + "." + start.y + "_" +
        end.d + "." + end.m + "." + end.y
}

export function getDefaultNameExactToDaysForRiverFloods(stationName, startTime, endTIme, startMeltingTime, endMeltingTime) {

    if (startTime === undefined || endTIme === undefined || startMeltingTime === undefined || endMeltingTime === undefined) {
        return stationName === undefined ? "" : stationName
    }

    let start = parseTimeStamp(startTime)
    let end = parseTimeStamp(endTIme)

    let meltingStart = parseTimeStamp(startMeltingTime)
    let meltingEnd = parseTimeStamp(endMeltingTime)

    let floodInfo = start.y === end.y && start.m === end.m && start.d === end.d ?
        "_[половодье: " + start.d + "." + start.m + "." + start.y + "]" :
        "_[половодье: " + start.d + "." + start.m + "." + start.y + "_" +
        end.d + "." + end.m + "." + end.y + "]"
    let meltingInfo = meltingStart.y === meltingEnd.y && meltingStart.m === meltingEnd.m && meltingStart.d === meltingEnd.d ?
        "_[снеготаяние: " + meltingStart.d + "." + meltingStart.m + "." + meltingStart.y + "]" :
        "_[снеготаяние: "  + meltingStart.d + "." + meltingStart.m + "." + meltingStart.y + "_" +
        meltingEnd.d + "." + meltingEnd.m + "." + meltingEnd.y + "]"

    return stationName + floodInfo + meltingInfo
}